<template>
  <div>
    <CRow class="mb-4">
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span class="font-weight-bold h6"><CIcon name="cil-layers" size="lg"/> {{ caption }}</span>
          </CCardHeader>
          <CCardBody>
            <CRow>

              <CCol col="12">
                <CSelect
                    :label="$t('organization')"
                    :horizontal="{label: 'col-sm-3 mt-1', input: 'col-sm-9 pl-2'}"
                    :options="organizations"
                    @update:value="onSelectOrganizations"

                />
              </CCol>
              <CCol col="12"  v-if="!isDepartment">
                <CRow>
                  <CCol col="3">
                    <label class="mt-2">{{ $t('department')}}</label>
                  </CCol>
                  <CCol>
                    <Multiselect class="os"
                                 :disabled="isAgencyDisabled"
                                 v-model="agencySelect"
                                 :options="agencys"
                                 label="label"
                                 track-by="value"
                                 :multiple="false"
                                 :search="true"
                    >
                    </Multiselect>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol col="12" v-if="!isYear" >
                <CInput :label="$t('year')"
                        type="number"
                        :horizontal="{label: 'col-sm-3 mt-1', input: 'col-sm-9 pl-2'}"
                        v-model="option.year"/>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'FilterOrganization',
  components: {Multiselect},
  props: {
    caption: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: true
    },
    option: {
      type: Object,
      default: {}
    },
    isYear: {
      type: Boolean,
      default: false
    },
    isDepartment: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      campus: [],
      semesters: [
        {
          label: " 1",
          value: 1
        }, {
          label: " 2",
          value: 2
        }, {
          label: " 3",
          value: 3
        }
      ],
      course: [],
      organizations:[],
      agencys:[],
      agencySelect : {label:"-", value:0},
      isAgencyDisabled: this.disabled,

    }


  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {

      this.$store.dispatch("organization/config",{})
      this.$store.dispatch("agency/config",{})

    },

    resolveLocalizedTitle(titles, lang = this.$store.getters['setting/lang']) {
      if (!Array.isArray(titles) || titles.length === 0) {
        return '';
      }

      return (titles.find((title) => title.key === lang) || titles[0] || {}).value || '';
    },

    buildOrganizationOptions(items) {
      return (Array.isArray(items) ? items : []).map((item) => ({
        label: this.resolveLocalizedTitle(item.title),
        value: item._id
      }));
    },

    buildAgencyOptions(items) {
      return [
        {label:"-", value:0},
        ...(Array.isArray(items) ? items : []).map((item) => ({
          label: this.resolveLocalizedTitle(item.title),
          value: item._id
        }))
      ];
    },

    syncAgencySelectionFromValue(value) {
      const nextValue = value == null ? 0 : value;
      const selected = this.agencys.find((agency) => agency.value === nextValue);
      this.agencySelect = selected || {label:"-", value:0};
    },

    syncAgencySelectionFromProfile() {
      const profile = this.profile || {};
      const profileAgency = profile.agency || {};

      if (profile.role !== 1 && profileAgency._id) {
        this.syncAgencySelectionFromValue(profileAgency._id);
        this.isAgencyDisabled = true;
        return;
      }

      if (profile.role === 1) {
        this.syncAgencySelectionFromValue(this.option.agency || this.agencySelect.value || 0);
        this.isAgencyDisabled = false;
      }
    },


    onSelectOrganizations(value, e) {
      this.option.campusId = value;
      this.$emit("option", this.option)
    },

    onSelectAgencys(value, e) {
      this.option.agency = value;
      this.$emit("option", this.option)
    },


  },


  computed: {
    ...mapGetters({
      lang: 'setting/lang',
      organization: 'organization/organization',
      agency: 'agency/item',
      profile: 'personal/profile',
    }),
  },

  watch: {

    lang(){
      const currentAgency = this.agencySelect && this.agencySelect.value != null ? this.agencySelect.value : 0;
      this.organizations = this.buildOrganizationOptions(this.organization);
      this.agencys = this.buildAgencyOptions(this.agency);
      this.syncAgencySelectionFromValue(currentAgency);
      this.syncAgencySelectionFromProfile();

    },


    organization: function (value) {

      this.organizations = this.buildOrganizationOptions(value);
    },
    agency: function (value) {

      const currentAgency = this.agencySelect && this.agencySelect.value != null ? this.agencySelect.value : 0;
      this.agencys = this.buildAgencyOptions(value);
      this.syncAgencySelectionFromValue(currentAgency);
      this.syncAgencySelectionFromProfile();

      // switch (this.$store.getters["personal/profile"].role) {
      //   case 2:
      //     this.agencySelect = {
      //       value: this.$store.getters["personal/profile"].agency._id,
      //       label: (this.$store.getters["personal/profile"].agency.title.find(t => t.key === lang) || {}).value || ''
      //     };
      //     this.disabled = true
      //     break;
      //   case 1:
      //     this.agencySelect = {
      //       value: this.$store.getters["personal/profile"].agency._id,
      //       label: (this.$store.getters["personal/profile"].agency.title.find(t => t.key === lang) || {}).value || ''
      //     };
      //     this.disabled = false
      //     break;
      //   default:
      //     this.agencySelect = {
      //       value: this.$store.getters["personal/profile"].agency._id,
      //       label: (this.$store.getters["personal/profile"].agency.title.find(t => t.key === lang) || {}).value || ''
      //     };
      //     this.disabled = true
      //     break;
      // }

    },

    agencySelect(value){
      this.option.agency = value && value.value != null ? value.value : 0;
      this.$emit("option", this.option)
    },

    disabled(value){
      this.isAgencyDisabled = value;
    },

    profile: {
      deep: true,
      handler() {
        this.syncAgencySelectionFromProfile();
      }
    },

    'option.year'(value){
      this.$emit("option", this.option)
    }
  }

}
</script>
<style>


</style>
